<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page">Home</li>
            </ol>
        </nav>
        <div class="container-fluid">
            <div v-if="successMessage" class="alert alert-success" role="alert">
                {{ successMessage }}
            </div>
            <div v-if="errorMessage" class="alert alert-danger" role="alert">
                {{ errorMessage }}
            </div>
            <h1 class="text-center">Listados de notificaciones mostradas en SCR y comunicaciones</h1>
            <div class="text-center layer-button">
                <button @click="$router.push('addNotification')" class="btn btn-primary">Crear nueva notificación</button>
            </div>
            <div v-if="showLoader" class="text-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <notifications-table
                    :notifications="notifications"
                    @error="onComponentError"
                    @success="onComponentSuccess"
            />
            <div class="text-center layer-button">
                <button @click="$router.push('addNotification')" class="btn btn-primary">Crear nueva notificación</button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import NotificationsTable from '@/components/NotificationsTable.vue'

    export default {
        name: 'home',
        components: {
            'notifications-table' : NotificationsTable
        },
        data () {
            return {
                notifications : [],
                successMessage : '',
                errorMessage : '',
                showLoader : false,
            };
        },
        methods: {
            initNotifications () {
                this.showLoader = true;
                axios
                    .get('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_notifications_web_json/Notifications/list')
                    .then(response => {
                        if (response.data.result) {
                            this.notifications = response.data.data
                        } else {
                            this.setNotificationsErrorMessage ();
                        }
                    }).catch(error => {
                        this.setNotificationsErrorMessage (error);
                    }).finally (() => {
                        this.showLoader = false;
                    });
            },
            onComponentError (message) {
                this.successMessage = '';
                this.errorMessage = message;
                this.scrollToTop();
                this.initNotifications ();
            },
            onComponentSuccess (message) {
                this.errorMessage = '';
                this.successMessage = message;
                this.scrollToTop();
                this.initNotifications ();
            },
            scrollToTop () {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            },
            setNotificationsErrorMessage () {
                this.errorMessage = "Se ha producido un error al consultar las notificaciones.";
            }
        },
        created () {
            this.initNotifications ();
        }
    }
</script>

<style>
    .layer-button {
        padding: 20px
    }
</style>